import { colors } from "../theme/tokens";
import { navigate } from "../router";

export default function TopBar({ showContribute, onContribute, isAdmin }) {
  return (
    <div style={{
      borderBottom: `1px solid ${colors.border}`,
      padding: "0 24px", height: 56,
      display: "flex", alignItems: "center", justifyContent: "space-between",
      position: "sticky", top: 0,
      background: "rgba(10,10,10,0.95)", backdropFilter: "blur(8px)",
      zIndex: 100,
    }}>
      <button
        onClick={() => navigate(isAdmin ? "#/admin" : "")}
        style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 10, padding: 0 }}
      >
        <img src="/logo-ap.png" alt="AnchorPoint FGC Barcelona" style={{ height: 34 }} />
        {isAdmin && (
          <span style={{ fontFamily: "var(--font-display)", fontSize: 10, color: colors.accent, letterSpacing: 3 }}>
            ADMIN
          </span>
        )}
      </button>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <a
          href="https://x.com/anchorpointfgc"
          target="_blank" rel="noopener noreferrer"
          style={{ color: "#333", textDecoration: "none", display: "flex", alignItems: "center", transition: "color 0.15s" }}
          onMouseEnter={e => e.currentTarget.style.color = "#888"}
          onMouseLeave={e => e.currentTarget.style.color = "#333"}
        >
          <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.743l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        </a>
        {showContribute && (
          <button className="btn-primary" style={{ fontSize: 12, padding: "7px 14px" }} onClick={onContribute}>
            + Anotar aporte
          </button>
        )}
      </div>
    </div>
  );
}
